import Header from '../Header';
import Score from '../Score';

const Home = () => (
  <div>
    <Header />
    <Score typeScore="T1W"/>
    <Score typeScore="T2W"/>
  </div>
)

export default Home;